import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import StaffDrawer from "components/drawer/StaffDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import EditDeleteButton from "components/table/EditDeleteButton";
import useToggleDrawer from "hooks/useToggleDrawer";
import React from "react";
import ShowHideButton from "components/table/ShowHideButton";
import { FaCircle } from "react-icons/fa";
const StaffTable = ({ staffdata, hideDelete, hideEdit }) => {
  const {
    title,
    serviceId,
    handleModalOpen,
    handleUpdate,
    handleResetPassword,
  } = useToggleDrawer();

  return (
    <>
      <DeleteModal id={serviceId} title={title} />

      <MainDrawer>
        <StaffDrawer id={serviceId} />
      </MainDrawer>

      <TableBody>
        {staffdata?.slice(0).map((data, index) => (
          <TableRow key={data.id}>
            <TableCell className="text-center text-xs">{index + 1}</TableCell>

            <TableCell className="text-center text-xs">
              {data.firstname + " " + data.lastname}
            </TableCell>
            <TableCell className="text-center text-xs">{data.email}</TableCell>
            <TableCell className="text-center text-xs">{data.mobile}</TableCell>
            <TableCell className="text-center text-xs">{data.role}</TableCell>
            <TableCell className="text-center text-xs">
              {hideEdit ? (
                <ShowHideButton id={data.id_employee} status={data.status} />
              ) : (
                <span>-</span>
              )}
            </TableCell>
            <TableCell className="text-center text-xs">
              <div className="flex justify-center items-center">
                {Number(data.login_status) === 1 ? (
                  <span className="text-green-500">
                    <FaCircle />
                  </span>
                ) : (
                  <span className="text-red-500">
                    <FaCircle />
                  </span>
                )}
              </div>
            </TableCell>

            {(hideEdit || hideDelete) && (
              <TableCell>
                <div className="flex justify-center">
                  <EditDeleteButton
                    title={data.name}
                    id={data.id_employee}
                    handleUpdate={handleUpdate}
                    handleModalOpen={handleModalOpen}
                    handleResetPassword={handleResetPassword}
                    hideEdit={hideEdit}
                    hideDelete={hideDelete}
                  />
                </div>
              </TableCell>
            )}
          </TableRow>
        ))}
      </TableBody>
    </>
  );
};

export default StaffTable;
